import { format } from 'date-fns';
import type { IssueId, IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type { Issue, Deployment } from '../../../../common/types';

type Row = {
	issueKey: string;
	issueSummary: string;
	issueUrl: string;
	deploymentDate: string;
	deploymentState: string;
	environmentType: string;
	environmentName: string;
};

const header: Row = {
	issueKey: 'Issue key',
	issueSummary: 'Issue summary',
	issueUrl: 'Issue URL',
	deploymentDate: 'Deployment date',
	deploymentState: 'Deployment state',
	environmentType: 'Environment type',
	environmentName: 'Environment name',
};

const buildRow = (
	issue: Issue,
	deployment: Deployment,
	buildUrl: (arg1: IssueKey) => string,
): Row => ({
	issueKey: issue.key,
	issueSummary: issue.summary,
	issueUrl: buildUrl(issue.key),
	deploymentDate: format(deployment.lastUpdated, 'yyyy-MM-dd HH:mm:ss'),

	deploymentState: deployment.state,
	environmentType: deployment.environment.type,
	environmentName: deployment.environment.displayName,
});

const stringifyRow = (row: Row): string => {
	const fields = [
		row.issueKey,
		row.issueSummary,
		row.issueUrl,
		row.deploymentDate,
		row.deploymentState,
		row.environmentType,
		row.environmentName,
	];

	const escapeField = (field: string) => field.replace(/"/g, '""');
	const quoteField = (field: string) => `"${field}"`;

	return fields.map(escapeField).map(quoteField).join(',');
};

type IssuesById = Record<IssueId, Issue>;

export const buildCsv = (
	deployments: Deployment[],
	issues: IssuesById,
	buildUrl: (arg1: IssueKey) => string,
): string => {
	const rows = deployments
		.flatMap((deployment) =>
			deployment.issueIds
				.filter((id) => issues[id] !== undefined)
				.map((id) => [issues[id], deployment]),
		)
		// @ts-expect-error - TS2345 - Argument of type '([issue, deployment]: [any, any]) => Row' is not assignable to parameter of type '(value: (Deployment | Issue | undefined)[], index: number, array: (Deployment | Issue | undefined)[][]) => Row'.
		.map(([issue, deployment]: [any, any]) => buildRow(issue, deployment, buildUrl)); // eslint-disable-line @typescript-eslint/no-explicit-any

	const rowsWithHeader = [header, ...rows];

	return rowsWithHeader.map(stringifyRow).join('\r\n');
};
